(() => {
  const technicalTitle = /\b(specifications?|specs|dimensions?|measurements?|cut[ -]?outs?)\b/i;
  const metricLabel = /\b(width|height|depth|diameter|dimensions|weight|capacity|btu|voltage|wattage|material|cooking area|fuel|model)\b/i;
  function plainSpecifications(detail) {
    const summary = detail.querySelector(':scope > summary');
    const section = document.createElement('section');
    for (const attribute of detail.attributes) {
      if (!['open', 'name', 'aria-expanded'].includes(attribute.name)) section.setAttribute(attribute.name, attribute.value);
    }
    section.classList.add('sf-visible-specifications');
    if (summary) {
      const heading = document.createElement('h3');
      heading.className = 'sf-specification-title';
      heading.textContent = summary.textContent.replace(/[+−–]\s*$/, '').trim();
      section.append(heading);
      summary.remove();
    }
    while (detail.firstChild) section.append(detail.firstChild);
    detail.replaceWith(section);
    return section;
  }
  function arrange(root) {
    if (root.dataset.sfSpecsArranged) return;
    root.dataset.sfSpecsArranged = 'true';
    const candidates = new Set();
    const add = node => {
      const detail = node.closest('details');
      if (detail && technicalTitle.test(detail.querySelector(':scope > summary')?.textContent || '')) {
        candidates.add(detail);
        return;
      }
      candidates.add(node.closest('section') || node);
    };
    root.querySelectorAll('h2,h3,h4,summary').forEach(heading => {
      if (!technicalTitle.test(heading.textContent)) return;
      if (heading.tagName === 'SUMMARY') {
        candidates.add(heading.parentElement);
      } else if (heading.closest('section')) {
        add(heading);
      } else {
        const next = heading.nextElementSibling;
        if (next?.matches('table,dl,ul,ol,figure,img,.specgrid,.sf-spec-grid,.rows,.sf-table-wrap,.table-wrap')) {
          const section = document.createElement('section');
          section.className = 'sf-visible-specifications';
          heading.before(section);
          section.append(heading, next);
          candidates.add(section);
        }
      }
    });
    root.querySelectorAll('table').forEach(table => {
      const text = table.textContent;
      const labels = [...table.querySelectorAll('th,td:first-child')].filter(cell => metricLabel.test(cell.textContent));
      if (technicalTitle.test(text) || labels.length >= 1) add(table);
    });
    root.querySelectorAll('section.sf-specs,.specgrid,.sf-spec-grid,.specifications,[data-specifications],.rows').forEach(node => {
      if (node.matches('.rows') && ![...node.querySelectorAll('strong,dt')].some(label => metricLabel.test(label.textContent))) return;
      add(node);
    });
    const blocks = [...candidates].filter(node => ![...candidates].some(other => other !== node && other.contains(node)));
    blocks.sort((a,b) => a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1);
    const groups = new Map();
    for (let block of blocks) {
      if (block.tagName === 'DETAILS') block = plainSpecifications(block);
      block.querySelectorAll('details').forEach(detail => {
        if (technicalTitle.test(detail.querySelector(':scope > summary')?.textContent || '')) plainSpecifications(detail);
      });
      const label = block.previousElementSibling;
      if (!block.matches('section') && label?.matches('span,p,h2,h3,h4') && /specification|dimensions|key details/i.test(label.textContent)) {
        const section = document.createElement('section');
        section.className = 'sf-visible-specifications';
        label.before(section);
        section.append(label, block);
        block = section;
      }
      let container = block.parentElement;
      while (container !== root && container.parentElement && container.parentElement !== root) container = container.parentElement;
      if (container === root || container.contains(block) && !container.matches('style,script')) {
        if (!groups.has(container)) groups.set(container, []);
        groups.get(container).push(block);
      }
    }
    for (const [container, specs] of groups) {
      const closing = [...container.children].reverse().find(child => !specs.includes(child) && (
        /(?:^|\s)(?:[a-z0-9]+-)*(?:cta|final)(?:[-_][a-z0-9_-]+)?(?:\s|$)/i.test(child.className || '') ||
        child.querySelector('form[action^="/cart/"],button[data-sf-concept-add]')
      ));
      for (const block of specs) {
        block.setAttribute('data-sf-bottom-specs', '');
        if (closing) container.insertBefore(block, closing);
        else container.append(block);
      }
    }
  }
  function init() {
    const roots = [...document.querySelectorAll('[data-sf-description-layout],.hdt-product__description .hdt-rte,.hdt-tab-item[data-type="tab_des"],.hdt-product-accordion__content.hdt-rte,.hdt-product-tab__item-content.hdt-rte')];
    roots.filter(root => !roots.some(other => other !== root && root.contains(other))).forEach(arrange);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href="#sf-forno-installation-fit"]');
    if (!link) return;
    const panel = document.getElementById('sf-forno-installation-fit');
    if (!panel) return;
    event.preventDefault();
    if (panel.tagName === 'DETAILS') panel.open = true;
    panel.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
    panel.querySelector('summary')?.focus({ preventScroll: true });
  });
  if (location.hash === '#sf-forno-installation-fit') {
    const panel = document.getElementById('sf-forno-installation-fit');
    if (panel?.tagName === 'DETAILS') panel.open = true;
  }
})();
